<template>
  <div>
      <div>
          <div class="top">
            <div class="item1"></div>
          </div>
          <div class="bottom">
            <div class="item2"></div>
            <div class="item3"></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'demo',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.top {
  width: 100%;
  display: flex;
  //z-index: 1;

  .item1 {
    width: 1000px;
    border: 1px solid red;
    background-color: red;
    height: 700px;
  }
}
.bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: -500px;
  //z-index: 2;

  .item2 {
    width: 800px;
    border: 1px solid blue;
    background-color: blue;
    height: 300px;

  }

  .item3 {
    width: 1000px;
    border: 1px solid black;
    background-color: black;
    height: 600px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/demo/demo.vue